<template>
  <section-vue
    class="trial-duration-explanation"
    v-if="subscriptionPlan.trialDays > 0">
    <div class="trial-duration-explanation__container">
      <div
        class="trial-duration-explanation__headline"
        v-html="$t('headline')" />

      <div
        v-if="!includeReminderStep"
        class="trial-duration-explanation__timeline">
        <trial-timeline :plan="subscriptionPlan" />
      </div>

      <div v-else>
        <trial-timeline-with-reminder-step :plan="subscriptionPlan" />
      </div>

      <div class="trial-duration-explanation__try-blinkist">
        <inline-banner-with-cta
          :cta-copy="ctaCopy"
          :cta-js-class="ctaJsClass"
          :piwik-category="piwikCategory"
          :plan="subscriptionPlan"
          :redirect-to-checkout-page="redirectToCheckoutPage"
          :logged-in-user-redirect="loggedInUserRedirect" />
      </div>
    </div>
  </section-vue>
</template>

<script>
import InlineBannerWithCta from "/shared/inline-banner-with-cta";
import TrialTimeline from "/features/trial-duration-explanation/components/trial-timeline";
import TrialTimelineWithReminderStep from "/shared/trial-timeline-with-reminder-step.vue";
import SectionVue from "/shared/section";

export default {
  name: "TrialDurationExplanation",
  components: {
    InlineBannerWithCta,
    TrialTimeline,
    TrialTimelineWithReminderStep,
    SectionVue
  },
  i18n: {
    messages: {
      en: { headline: "Curious? <br>Try it for free" },
      de: { headline: "Das kostenlose Probeabo" }
    }
  },
  props: {
    ctaCopy: {
      type: String,
      default: null
    },
    ctaJsClass: {
      type: String,
      default: null
    },
    piwikCategory: {
      type: String,
      default: "body-20200409-trial_duration_explanation"
    },
    subscriptionPlan: {
      type: Object,
      default: null
    },
    redirectToCheckoutPage: {
      type: Boolean,
      default: false
    },
    loggedInUserRedirect: {
      type: String,
      default: null
    },
    includeReminderStep: {
      type: Boolean,
      default: null
    }
  }
};
</script>

<style lang="scss">
.trial-duration-explanation {
  @include font-family(sans-serif);

  display: flex;
  align-items: flex-end;

  &__container {
    @include container;
  }

  &__headline {
    @include font-style(h2);

    width: 100%;
    margin-bottom: $spacing-32;

    text-align: center;

    br { /* stylelint-disable-line selector-nested-pattern */
      @include media(min-width, m) {
        display: none;
      }
    }

    @include media(min-width, m) {
      margin-bottom: 5.25rem;
    }
  }

  &__timeline {
    margin-bottom: $spacing-128;

    @include media(min-width, m) {
      margin-bottom: $spacing-96;
    }
  }
}
</style>
